var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1875 1.55H2.8125C2.24296 1.55 1.78125 2.0201 1.78125 2.6V19.4C1.78125 19.9799 2.24296 20.45 2.8125 20.45H15.1875C15.757 20.45 16.2188 19.9799 16.2188 19.4V2.6C16.2188 2.0201 15.757 1.55 15.1875 1.55ZM2.8125 0.5C1.67341 0.5 0.75 1.4402 0.75 2.6V19.4C0.75 20.5598 1.67341 21.5 2.8125 21.5H15.1875C16.3266 21.5 17.25 20.5598 17.25 19.4V2.6C17.25 1.4402 16.3266 0.5 15.1875 0.5H2.8125Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 4.35H4.875C4.68515 4.35 4.53125 4.5067 4.53125 4.7V14.5C4.53125 14.6933 4.68515 14.85 4.875 14.85H13.125C13.3148 14.85 13.4688 14.6933 13.4688 14.5V4.7C13.4688 4.5067 13.3148 4.35 13.125 4.35ZM4.875 3.3C4.11561 3.3 3.5 3.9268 3.5 4.7V14.5C3.5 15.2732 4.11561 15.9 4.875 15.9H13.125C13.8844 15.9 14.5 15.2732 14.5 14.5V4.7C14.5 3.9268 13.8844 3.3 13.125 3.3H4.875Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1875 1.55H2.8125C2.24296 1.55 1.78125 2.0201 1.78125 2.6V19.4C1.78125 19.9799 2.24296 20.45 2.8125 20.45H15.1875C15.757 20.45 16.2188 19.9799 16.2188 19.4V2.6C16.2188 2.0201 15.757 1.55 15.1875 1.55ZM2.8125 0.5C1.67341 0.5 0.75 1.4402 0.75 2.6V19.4C0.75 20.5598 1.67341 21.5 2.8125 21.5H15.1875C16.3266 21.5 17.25 20.5598 17.25 19.4V2.6C17.25 1.4402 16.3266 0.5 15.1875 0.5H2.8125Z",
    stroke: "#909090",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 4.35H4.875C4.68515 4.35 4.53125 4.5067 4.53125 4.7V14.5C4.53125 14.6933 4.68515 14.85 4.875 14.85H13.125C13.3148 14.85 13.4688 14.6933 13.4688 14.5V4.7C13.4688 4.5067 13.3148 4.35 13.125 4.35ZM4.875 3.3C4.11561 3.3 3.5 3.9268 3.5 4.7V14.5C3.5 15.2732 4.11561 15.9 4.875 15.9H13.125C13.8844 15.9 14.5 15.2732 14.5 14.5V4.7C14.5 3.9268 13.8844 3.3 13.125 3.3H4.875Z",
    stroke: "#909090",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.4b6a0b5b.svg";
export { ForwardRef as ReactComponent };var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1875 1.55H2.8125C2.24296 1.55 1.78125 2.0201 1.78125 2.6V19.4C1.78125 19.9799 2.24296 20.45 2.8125 20.45H15.1875C15.757 20.45 16.2188 19.9799 16.2188 19.4V2.6C16.2188 2.0201 15.757 1.55 15.1875 1.55ZM2.8125 0.5C1.67341 0.5 0.75 1.4402 0.75 2.6V19.4C0.75 20.5598 1.67341 21.5 2.8125 21.5H15.1875C16.3266 21.5 17.25 20.5598 17.25 19.4V2.6C17.25 1.4402 16.3266 0.5 15.1875 0.5H2.8125Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 4.35H4.875C4.68515 4.35 4.53125 4.5067 4.53125 4.7V14.5C4.53125 14.6933 4.68515 14.85 4.875 14.85H13.125C13.3148 14.85 13.4688 14.6933 13.4688 14.5V4.7C13.4688 4.5067 13.3148 4.35 13.125 4.35ZM4.875 3.3C4.11561 3.3 3.5 3.9268 3.5 4.7V14.5C3.5 15.2732 4.11561 15.9 4.875 15.9H13.125C13.8844 15.9 14.5 15.2732 14.5 14.5V4.7C14.5 3.9268 13.8844 3.3 13.125 3.3H4.875Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1875 1.55H2.8125C2.24296 1.55 1.78125 2.0201 1.78125 2.6V19.4C1.78125 19.9799 2.24296 20.45 2.8125 20.45H15.1875C15.757 20.45 16.2188 19.9799 16.2188 19.4V2.6C16.2188 2.0201 15.757 1.55 15.1875 1.55ZM2.8125 0.5C1.67341 0.5 0.75 1.4402 0.75 2.6V19.4C0.75 20.5598 1.67341 21.5 2.8125 21.5H15.1875C16.3266 21.5 17.25 20.5598 17.25 19.4V2.6C17.25 1.4402 16.3266 0.5 15.1875 0.5H2.8125Z",
    stroke: "#909090",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 4.35H4.875C4.68515 4.35 4.53125 4.5067 4.53125 4.7V14.5C4.53125 14.6933 4.68515 14.85 4.875 14.85H13.125C13.3148 14.85 13.4688 14.6933 13.4688 14.5V4.7C13.4688 4.5067 13.3148 4.35 13.125 4.35ZM4.875 3.3C4.11561 3.3 3.5 3.9268 3.5 4.7V14.5C3.5 15.2732 4.11561 15.9 4.875 15.9H13.125C13.8844 15.9 14.5 15.2732 14.5 14.5V4.7C14.5 3.9268 13.8844 3.3 13.125 3.3H4.875Z",
    stroke: "#909090",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.4b6a0b5b.svg";
export { ForwardRef as ReactComponent };